import { render, staticRenderFns } from "./WSpinner.vue?vue&type=template&id=c7dc1eca&scoped=true"
import script from "./WSpinner.vue?vue&type=script&lang=js"
export * from "./WSpinner.vue?vue&type=script&lang=js"
import style0 from "./WSpinner.vue?vue&type=style&index=0&id=c7dc1eca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dc1eca",
  null
  
)

export default component.exports